import React from 'react';
import { useTranslation } from 'react-i18next';
import noImage from '../../../../assets/images/no-image.png';
import { checkArray, imageUrl } from '../../../../Components/helper';

function SymbolTableGroup({ SymbolData, handleCheck, handleCheckAll, isAllSymbolChecked, checkedIds, handleDelete, isPageDisable, CareDeleteAccess }) {
  const setImage = (item) => {
    let imagePath = '';
    if (item?.image && item.image.includes('data:image/png;base64')) {
      imagePath = item.image;
    } else if (item?.image) {
      imagePath = `${imageUrl}/${item.image}`;
    } else {
      imagePath = noImage;
    }
    return imagePath;
  };
  const { t } = useTranslation('common');

  return (
    <div className="table-responsive">
      <table className="table custom-table layout-fixed">
        <thead>
          <tr>
            <th className="w-80px w-xs-40px">
              <div className="checkbox-label no-label margin-auto">
                <input
                  type="checkbox"
                  disabled={isPageDisable}
                  name="check_all_grp_symbol"
                  id="check_all_grp_symbol"
                  onChange={(e) => handleCheckAll(e)}
                  checked={isAllSymbolChecked}
                />
                <label htmlFor="check_all_grp_symbol" className="chklabel">
                  <span />
                </label>
              </div>
            </th>
            <th className="w-100px">{t('CARE_LABELS.GROUP.SYMBOL_TABLE_GROUP.IMAGE')}</th>
            <th className="w-300px w-xs-150px">{t('CARE_LABELS.GROUP.SYMBOL_TABLE_GROUP.CODE')}</th>
            <th className="w-300px">{t('CARE_LABELS.GROUP.SYMBOL_TABLE_GROUP.DESCRIPTION')}</th>
            <th className="w-200px">{t('CARE_LABELS.GROUP.SYMBOL_TABLE_GROUP.CARE_TYPE')}</th>
            {CareDeleteAccess && <th className="w-80px">{t('CARE_LABELS.GROUP.SYMBOL_TABLE_GROUP.ACTION')}</th>}
          </tr>
        </thead>
        <tbody>
          {checkArray(SymbolData) ? (
            SymbolData.map((element, i) => {
              return (
                <tr key={element._id}>
                  <td>
                    <div className="checkbox-label no-label margin-auto">
                      <input
                        type="checkbox"
                        id={`check_grp_symbol_${i}`}
                        onChange={(e) => handleCheck(e, element._id)}
                        checked={checkedIds.includes(element._id)}
                        disabled={isPageDisable}
                      />
                      <label htmlFor={`check_grp_symbol_${i}`} className="chklabel">
                        <span />
                      </label>
                    </div>
                  </td>
                  <td>
                    <img src={setImage(element)} width={80} alt="no img" />
                  </td>
                  <td>{element.code}</td>
                  <td>{element.description}</td>
                  <td>{element.careType}</td>
                  {CareDeleteAccess && (
                    <td>
                      <div className="d-flex align-items-center">
                        <button
                          title={t('CARE_LABELS.GROUP.SYMBOL_TABLE_GROUP.DELETE')}
                          type="button"
                          disabled={isPageDisable}
                          onClick={() => handleDelete(element?._id)}
                          className="filter-btn filter-button_delete"
                        >
                          <i className="icon-delete" />
                        </button>
                      </div>
                    </td>
                  )}
                </tr>
              );
            })
          ) : (
            <tr>
              <td colSpan="5" className="text-center">
                {t('CARE_LABELS.GROUP.SYMBOL_TABLE_GROUP.NO_SYMBOL_FOUND')}
              </td>
            </tr>
          )}
        </tbody>
      </table>
    </div>
  );
}

export default SymbolTableGroup;
